import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";

import { HiOutlineClock, HiMiniUser } from "react-icons/hi2";
import { LiaIndustrySolid } from "react-icons/lia";
import { IoLogoWhatsapp } from "react-icons/io";
import { MdEmail, MdSchool } from "react-icons/md";

import { CaseIcon, InstagramIcon, LinkedinIcon } from "../../../Icons/Icons";
import { BarProgress } from "../Barprogress/barprogress";

import { getCandidateInfo } from "../../../API/Candidates/Cadidate.js";

import { getCandidateProfesionalExperiences } from "../../../API/Candidates/Experience";
import { getCandidateFormationValues } from "../../../API/Candidates/Education";
import { getIndustryTypeList } from "../../../API/Lists/industryType.js";

export function Profile() {
	const language = useIntl();

	const [profile, setProfile] = useState(null);

	const load = useCallback(async () => {
		try {
			const user = JSON.parse(localStorage.getItem("user"));

			const id = user.id;

			const [info, profetional, formation, industryList] = await Promise.all([
				getCandidateInfo(id),
				getCandidateProfesionalExperiences(id),
				getCandidateFormationValues(id),
				getIndustryTypeList(),
			]);

			const industry = industryList.filter((industry) => profetional.items.professional_experiences.some((user) => user.industry === industry.id));

			setProfile({
				info: info.item,
				profetional: profetional.items,
				formation: formation.items,
				industry,
			});
		} catch (error) {
			console.error("ERROR: ", error);
		}
	}, []);

	useEffect(() => {
		load();
	}, [load]);

	const CalcCandidateExp = (exp) => {
		if (exp) {
			var date = new Date(exp[0]?.entry_date);
			let years = new Date().getFullYear() - date.getFullYear();
			let months = new Date().getMonth() + 1 - date.getMonth();

			if (months < 0) {
				months = months * -1;
				years = years - 1;
			}

			if (language.locale === "PT-BR") {
				return `${years} ano(s) e ${months} mes(es) de carreira`;
			}

			return `${years} año(s) y ${months} mes(es) de carrera`;
		}
		return "--";
	};

	const formatDate = (inputDate) => {
		if (/^\d{4}-\d{2}-\d{2}$/.test(inputDate)) {
			const parts = inputDate.split("-");
			const year = parts[0];
			const month = parts[1];

			return `${month}/${year}`;
		}
		return inputDate;
	};

	if (!profile) {
		return <div className="w-100 h-100 d-flex align-items-center justify-content-center">loading...</div>;
	}

	return (
		<div className="overflow-hidden bg-white border position-relative" style={{ borderRadius: 24 }}>
			<div className="w-100" style={{ height: 179, background: "linear-gradient(87deg, #8574f1 0%, rgba(41,166,215,1) 100%)" }}></div>
			<div className="position-relative w-100 pb-3" style={{ boxSizing: "border-box" }}>
				<div className="bg-white w-auto border border-purple p-4 mx-5" style={{ borderRadius: 12, marginTop: -100, boxSizing: "border-box" }}>
					<div className="row">
						<div className="col-xl-2 col-sm-12 d-flex align-items-center justify-content-center mb-3">
							<div className="d-flex justify-content-center align-items-center rounded-circle" style={{ width: "5vw", height: "5vw", background: "#E2E4FD" }}>
								<HiMiniUser color="#8574F1" size={"4.5vw"} />
							</div>
						</div>
						<div className="col-sm-12 col-xl-6 px-5 mb-4 mb-xxl-0">
							<h5 className="m-0 p-0 mb-1" style={{ fontWeight: 700, fontSize: 22 }}>
								{profile?.info.name}
							</h5>
							<p className="m-0 p-0 text-purple" style={{ fontSize: 18 }}>
								{profile?.info.jobname}
							</p>
							<p className="m-0 p-0 text-purple" style={{ fontSize: 18 }}>
								{profile?.info.country}
							</p>
							<div className="d-flex mt-2 w-100">
								{profile?.info.areas.slice(0, 3).map((item) => (
									<div
										key={item}
										className="rounded-pill px-2 border border-purple mx-1 overflow-hidden"
										style={{ background: "#F6F1FF", whiteSpace: "nowrap", width: "130px", textOverflow: "ellipsis" }}
										title={item}
									>
										{"#"}
										{item}
									</div>
								))}
							</div>
						</div>
						<div className="col-sm-12 col-xl-4">
							<div className="d-flex h-100 gap-3 align-items-center justify-content-xl-end justify-content-start opacity-50 align-xs-items-center">
								<InstagramIcon size={22} />
								<LinkedinIcon size={22} />
								<MdEmail size={22} color="#9391A1" />
								<IoLogoWhatsapp size={22} color="#25d366" />
							</div>
						</div>
					</div>
				</div>
				<div className="container overflow-auto" style={{ height: "65vh" }}>
					<div className="row mt-5">
						<div className="col-xl-5 col-sm-12">
							<h4 className="mb-5" style={{ fontWeight: 600, fontSize: 20 }}>
								Experiência Profesional
							</h4>
							<div className="d-flex align-items-center my-4">
								<HiOutlineClock size={20} color="#8574F1" />
								<span className="ms-2">{CalcCandidateExp(profile.profetional.professional_experiences)}</span>
							</div>
							<div className="d-flex align-items-center my-4">
								<CaseIcon size={18} />
								<div className="ms-2 d-flex w-100 align-items-center">
									{profile.profetional.professional_experiences.map((item, index) => (
										<div key={index} className="d-flex align-items-center">
											<div title={item.jobname}>{item.jobname}</div>
											{index < profile.profetional.professional_experiences.length - 1 && (
												<span className="text-grey mx-2" style={{ fontSize: 20 }}>
													|
												</span>
											)}
										</div>
									))}
								</div>
							</div>
							<div className="d-flex w-100 align-items-center flex-nowrap">
								<LiaIndustrySolid size={20} color="#8574F1" />
								<div className="ms-2 d-flex w-100 align-items-center flex-nowrap">
									{profile.industry.map((item, index) => (
										<div key={index} className="d-flex align-items-center">
											<div style={{ textOverflow: "ellipsis", width: 80, overflow: "hidden", whiteSpace: "nowrap" }} title={item.name}>
												{item.name}
											</div>
											{index < profile.profetional.professional_experiences.length - 1 && (
												<span className="text-grey mx-2" style={{ fontSize: 20 }}>
													|
												</span>
											)}
										</div>
									))}
								</div>
							</div>
						</div>
						<div className="col-xl-5 col-sm-12 mt-sm-5 mt-xl-0">
							<h4 className="mb-5" style={{ fontWeight: 600, fontSize: 20 }}>
								Formação
							</h4>
							{profile.formation.formacions.map((item, index) => (
								<div className="my-4" key={index}>
									<MdSchool size={20} color="#05C8AA" />
									<span className="mx-2" style={{ fontWeight: 500 }}>
										{item.university}
									</span>
									<p className="text-dark-grey ms-4">{item.name}</p>
								</div>
							))}
						</div>
						<div className="col-xl-2 col-sm-12 mt-sm-5 mt-xl-0">
							<h4 className="text-dark-grey opacity-75" style={{ fontWeight: 600, fontSize: 20 }}>
								Propósito
							</h4>
						</div>
					</div>
					<div className="row border-top border-grey py-4 mt-5">
						<div className="col opacity-25 mt-5">
							<h5 className="mb-4" style={{ fontWeight: 600 }}>
								Cultura
							</h5>
							<div className="row">
								<div className="col">
									<p className="text-purple m-0" style={{ fontWeight: 600, fontSize: 16 }}>
										Indefinido
									</p>
									<p style={{ fontWeight: 400, fontSize: 14 }}>Indefinido</p>
								</div>
								<div className="col-5">
									<BarProgress size={120} />
								</div>
							</div>
							<div className="row">
								<div className="col">
									<div className="d-flex w-100 gap-4">
										<BarProgress size={80} color="#8574F1" />
										<BarProgress size={80} color="#41C8FF" />
										<BarProgress size={80} color="#50F8D5" />
									</div>
								</div>
							</div>
						</div>
						<div className="col ps-0 ps-xl-5 mt-5">
							<h5 className="mb-4" style={{ fontWeight: 600 }}>
								Conocimento
							</h5>
							<p className="text-purple" style={{ fontWeight: 600, fontSize: 16 }}>
								Idiomas
							</p>
							<div>
								{profile?.formation?.languages.map((item) => (
									<div key={item.language}>
										<h5 style={{ fontSize: 14, fontWeight: 600 }}>{item.language}</h5>
										<div className="d-flex gap-2">
											<div>
												<div className={`rounded-pill bg-purple ${item.language_level_id <= 0 ? "opacity-50" : ""}`} style={{ width: 72, height: 7 }}></div>
												<p className="w-100 text-center" style={{ fontSize: 14, fontWeight: 500 }}>
													Básico
												</p>
											</div>
											<div>
												<div className={`rounded-pill bg-purple ${item.language_level_id <= 1 ? "opacity-50" : ""}`} style={{ width: 72, height: 7 }}></div>
												<p className="w-100 text-center" style={{ fontSize: 14, fontWeight: 500 }}>
													Intermédio
												</p>
											</div>
											<div>
												<div className={`rounded-pill bg-purple ${item.language_level_id <= 2 ? "opacity-50" : ""}`} style={{ width: 72, height: 7 }}></div>
												<p className="w-100 text-center" style={{ fontSize: 14, fontWeight: 500 }}>
													Avanzado
												</p>
											</div>
											<div>
												<div className={`rounded-pill bg-purple ${item.language_level_id <= 3 ? "opacity-50" : ""}`} style={{ width: 72, height: 7 }}></div>
												<p className="w-100 text-center" style={{ fontSize: 14, fontWeight: 500 }}>
													Fluído
												</p>
											</div>
										</div>
									</div>
								))}
							</div>
							<p className="text-blue opacity-25" style={{ fontWeight: 600, fontSize: 16 }}>
								Habilidades
							</p>
							<div className="opacity-25">
								<h5 style={{ fontSize: 14, fontWeight: 600 }}>Indefinido</h5>
								<div className="d-flex gap-2">
									<div>
										<div className={`rounded-pill bg-blue`} style={{ width: 72, height: 7 }}></div>
										<p className="w-100 text-center" style={{ fontSize: 14, fontWeight: 500 }}>
											Básico
										</p>
									</div>
									<div>
										<div className={`rounded-pill bg-blue`} style={{ width: 72, height: 7 }}></div>
										<p className="w-100 text-center" style={{ fontSize: 14, fontWeight: 500 }}>
											Intermédio
										</p>
									</div>
									<div>
										<div className={`rounded-pill bg-blue`} style={{ width: 72, height: 7 }}></div>
										<p className="w-100 text-center" style={{ fontSize: 14, fontWeight: 500 }}>
											Avanzado
										</p>
									</div>
									<div>
										<div className={`rounded-pill bg-blue opacity-50`} style={{ width: 72, height: 7 }}></div>
										<p className="w-100 text-center" style={{ fontSize: 14, fontWeight: 500 }}>
											Fluído
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="mt-5 row border-top border-grey py-4">
						<div className="col ">
							<h5 style={{ fontWeight: 600 }}>Histórico Profesional</h5>

							{profile.profetional.professional_experiences.map((item, index) => (
								<div key={index} className="p-3 border rounded-3 d-inline-block m-1" style={{ width: 250 }}>
									<h5>{item.jobname}</h5>
									<p className="m-0" style={{ color: "#8574f1", fontSize: 14 }}>
										{item.company}
									</p>
									<small style={{ color: "#8F95B2", fontSize: 11 }}>
										{formatDate(item.entry_date)} - {formatDate(item.departure_date)}
									</small>
								</div>
							))}
						</div>
					</div>
					<div className="mt-5 row border-top border-grey py-4 opacity-50">
						<div className="col ">
							<h5 style={{ fontWeight: 600 }}>Referencias</h5>
							<div className="p-3 rounded-3 d-inline-block m-1" style={{ width: 250, background: "#F4F6FA" }}>
								<h5 className="m-0" style={{ color: "#453D9E", fontWeight: 600 }}>
									Nombre
								</h5>
								<small style={{ color: "#8574F1", fontWeight: 600, fontSize: 14 }}>Cargo</small>
								<p className="mt-3" style={{ color: "#444258", fontSize: 14 }}>
									Agrega una referencia.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
